var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('GmapMap',{staticStyle:{"width":"100%","height":"500px"},attrs:{"center":{lat: 52, lng: 5},"zoom":5}},[_c('gmap-polygon',{attrs:{"paths":_vm.paths,"editable":false},on:{"paths_changed":function($event){return _vm.updateEdited($event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }